import { runSync } from "@/lib/offline";

let online = typeof navigator === "undefined" ? true : navigator.onLine;
let timer = null;
let apiRef = null;
let probing = false;

export const isNetOnline = () => online;

const setStatus = (v) => {
  if (v === online) return;
  online = v;
  window.dispatchEvent(new CustomEvent("net-status", { detail: { online: v } }));
  if (v && apiRef) runSync(apiRef);
};

export const reportNetSuccess = () => setStatus(true);
export const reportNetFailure = () => {
  setStatus(false);
  probe();
};

const probe = async () => {
  if (probing) return;
  probing = true;
  try {
    const ctrl = new AbortController();
    const to = setTimeout(() => ctrl.abort(), 6000);
    const r = await fetch(`/api/health?t=${Date.now()}`, { cache: "no-store", signal: ctrl.signal });
    clearTimeout(to);
    setStatus(r.ok);
  } catch {
    setStatus(false);
  } finally {
    probing = false;
  }
};

export const startHeartbeat = (api) => {
  apiRef = api;
  if (timer || typeof window === "undefined") return;
  probe();
  timer = setInterval(probe, 10000);
  window.addEventListener("online", probe);
  window.addEventListener("offline", () => setStatus(false));
  document.addEventListener("visibilitychange", () => { if (!document.hidden) probe(); });
};
